import React from "react";
import styled from "styled-components";
import { useCurrentFrame } from "../use-current-frame";
import { interpolate } from "../interpolate";
import { spring } from "../Spring";

const Container = styled.div`
    display: inline-flex;
`;

const Holder = styled.div``;

function BreathAnimation(props) {
    const frame = useCurrentFrame();

    const { children, videoConfig = {} } = props;
    const fps = videoConfig.fps || 30;

    const opacity = spring({
        frame,
        fps,
    });
    const scale = interpolate(
        frame / 5,
        [0, fps - 25, fps - 15, fps],
        [0.7, 1.1, 1, 1],
        // [1.3, 0.9, 1, 1],
        {
            extrapolateRight: "clamp",
            extrapolateLeft: "clamp",
        }
    );

    // const opacity = scale > 1.2 || scale < 0.8 ? 0 : 1;

    return (
        <Container>
            <Holder
                style={{
                    opacity: opacity,
                    transform: `scale(${scale}, ${scale})`,
                }}
            >
                {children}
            </Holder>
        </Container>
    );
}

export default React.memo(BreathAnimation);
